import { createAction } from '@reduxjs/toolkit';

import type { ApiDomainFoldersResponse } from './domainFolders.types';

export const loadDomainFoldersSuccess = createAction<ApiDomainFoldersResponse | undefined>('domainFolders/load/success');
